module.exports = __webpack_public_path__ + "img/app-web.31ef01b5.svg";